/**
 * File Name          : data-type.model.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.0.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_BACKGROUNDTECH_LICENSE.txt', which is part of this source code package.
 */

export enum DATA_TYPE
{
	NA = 0x00,
	UINT8,
	UINT16,
	UINT32,
	UINT64,
	INT8,
	INT16,
	INT32,
	INT64,
	FLOAT32,
	FLOAT64,
	ENUM8,
};

export namespace DATA_TYPE {
    export function from(b: number): DATA_TYPE | null {
        for (const key in DATA_TYPE) {
            if (DATA_TYPE[key as keyof typeof DATA_TYPE] === b) {
                return DATA_TYPE[key as keyof typeof DATA_TYPE] as DATA_TYPE;
            }
        }
        return null;
    }
}